import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslocoService, TRANSLOCO_TRANSPILER } from '@jsverse/transloco';
import { Observable, catchError, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AnalyticsService } from '../analytics/analytics.service';

@Injectable({ providedIn: 'root' })
export class MarkdownService {
  private http = inject(HttpClient);
  private translocoService = inject(TranslocoService);
  private analyticsService = inject(AnalyticsService);
  private transpiler = inject(TRANSLOCO_TRANSPILER);

  loadMarkdown(key: string, params?: Record<string, unknown>): Observable<string> {
    const lang = this.translocoService.getActiveLang();
    const url = `assets/i18n/markdown/${key}/${lang}.md?b=${environment.build}`;

    return this.http.get(url, { responseType: 'text' }).pipe(
      catchError((error) => {
        this.analyticsService.handleError(error, `Load markdown ${key} for lang "${lang}"`);
        return this.loadFallback(key);
      }),
      map((content) => this.interpolate(content, params)),
    );
  }

  private loadFallback(key: string): Observable<string> {
    const url = `assets/i18n/markdown/${key}/en.md?b=${environment.build}`;
    return this.http.get(url, { responseType: 'text' }).pipe(catchError(() => of('')));
  }

  private interpolate(content: string, params?: Record<string, unknown>): string {
    if (!params) {
      return content;
    }
    return this.transpiler.transpile({ key: 'markdown', value: content, params, translation: {} });
  }
}
